/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { InviteCode, InviteCodeInterface } from "../InviteCode";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "utm",
        type: "bytes32",
      },
    ],
    name: "InviteCodeCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "usedBy",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "utm",
        type: "bytes32",
      },
    ],
    name: "InviteCodeUsed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newUser",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
    ],
    name: "Referral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "CREATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "numberToAdd",
        type: "uint256",
      },
    ],
    name: "addMaxUses",
    outputs: [
      {
        internalType: "uint256",
        name: "newMaximum",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maxUses",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "uses",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "instancesPerUse",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "valuePerInstance",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "associateWith",
            type: "address",
          },
          {
            internalType: "bytes32",
            name: "utm",
            type: "bytes32",
          },
        ],
        internalType: "struct InviteCode.InviteCodeMetadata",
        name: "metadata",
        type: "tuple",
      },
    ],
    name: "create",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "inviteCodes",
    outputs: [
      {
        internalType: "uint256",
        name: "maxUses",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "uses",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "instancesPerUse",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "valuePerInstance",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "associateWith",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "utm",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
      {
        internalType: "address",
        name: "newUser",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
    ],
    name: "noticeReferral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "codeHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "usedBy",
        type: "address",
      },
    ],
    name: "use",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b506200003e7f828634d95e775031b9ff576b159a8509d3053581a8c9c4d7d86899e0afcd882f336200007d565b6200006a7f14823911f2da1b49f045a0929a60b8c1f2a7fc8c06c7284ca3e8ab4e193a08c8336200007d565b620000776000336200007d565b62000191565b6200008982826200008d565b5050565b600082815260208181526040909120620000b29183906200062762000106821b17901c565b156200008957620000c262000126565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b60006200011d836001600160a01b0384166200012a565b90505b92915050565b3390565b600062000138838362000179565b620001705750815460018181018455600084815260208082209093018490558454848252828601909352604090209190915562000120565b50600062000120565b60009081526001919091016020526040902054151590565b610c9380620001a16000396000f3fe608060405234801561001057600080fd5b50600436106100c55760003560e01c806313119161146100ca5780631bd2b425146100e8578063248a9ca3146100fd5780632e3f98a7146101105780632f2ff15d1461012357806336568abe1461013657806341804e22146101495780635cb0610c146101695780638aeda25a1461018e5780639010d07c1461019657806391d14854146101b6578063a217fddf146101c9578063ca15c873146101d1578063d547741f146101e4578063fc6a7365146101f7575b600080fd5b6100d261020a565b6040516100df91906109eb565b60405180910390f35b6100fb6100f63660046108ee565b61021c565b005b6100d261010b36600461092e565b6102a1565b6100d261011e3660046109ab565b6102b9565b6100fb610131366004610946565b61030f565b6100fb610144366004610946565b610376565b61015c610157366004610975565b6103d7565b6040516100df91906109e0565b61017c61017736600461092e565b610465565b6040516100df96959493929190610a77565b6100d26104a4565b6101a96101a43660046109ab565b6104b6565b6040516100df91906109cc565b61015c6101c4366004610946565b6104d5565b6100d26104ed565b6100d26101df36600461092e565b6104f2565b6100fb6101f2366004610946565b610509565b6100d2610205366004610946565b610562565b600080516020610c0f83398151915281565b610236600080516020610c0f8339815191526101c461063c565b61025b5760405162461bcd60e51b8152600401610252906109f4565b60405180910390fd5b80826001600160a01b0316846001600160a01b03167fd89e48f8e4f9ca1a14b18125d051f601bc9b42c7437b00ddaf7aa84d9fbe57e760405160405180910390a4505050565b6000818152602081905260409020600201545b919050565b60006102d5600080516020610bbf8339815191526101c461063c565b6102f15760405162461bcd60e51b815260040161025290610a47565b50600082815260016020526040902080548201908190555b92915050565b60008281526020819052604090206002015461032d906101c461063c565b6103685760405162461bcd60e51b815260040180806020018281038252602f815260200180610b90602f913960400191505060405180910390fd5b6103728282610640565b5050565b61037e61063c565b6001600160a01b0316816001600160a01b0316146103cd5760405162461bcd60e51b815260040180806020018281038252602f815260200180610c2f602f913960400191505060405180910390fd5b61037282826106a9565b60006103f3600080516020610bbf8339815191526101c461063c565b61040f5760405162461bcd60e51b815260040161025290610a47565b600083815260016020526040902082906104298282610ac1565b505060405160a08301359084907fc8752a1b1457ea25d7272024a77b7d57d709ceed5782a9b29671555338a0d55590600090a350600192915050565b60016020819052600091825260409091208054918101546002820154600383015460048401546005909401549293919290916001600160a01b03169086565b600080516020610bbf83398151915281565b60008281526020819052604081206104ce9083610712565b9392505050565b60008281526020819052604081206104ce908361071e565b600081565b600081815260208190526040812061030990610733565b600082815260208190526040902060020154610527906101c461063c565b6103cd5760405162461bcd60e51b8152600401808060200182810382526030815260200180610bdf6030913960400191505060405180910390fd5b600061057e600080516020610c0f8339815191526101c461063c565b61059a5760405162461bcd60e51b8152600401610252906109f4565b600083815260016020526040902080546105c65760405162461bcd60e51b815260040161025290610a21565b6001808201805490910190819055815410156105e157600080fd5b60058101546040516001600160a01b0385169086907fbd2f3f7592741e58127d21c362581529bba4580e42d50c293aebf776ff2ec76590600090a4600101549392505050565b60006104ce836001600160a01b03841661073e565b3390565b60008281526020819052604090206106589082610627565b156103725761066561063c565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b60008281526020819052604090206106c19082610788565b15610372576106ce61063c565b6001600160a01b0316816001600160a01b0316837ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b60405160405180910390a45050565b60006104ce838361079d565b60006104ce836001600160a01b038416610801565b600061030982610819565b600061074a8383610801565b61078057508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610309565b506000610309565b60006104ce836001600160a01b03841661081d565b815460009082106107df5760405162461bcd60e51b8152600401808060200182810382526022815260200180610b6e6022913960400191505060405180910390fd5b8260000182815481106107ee57fe5b9060005260206000200154905092915050565b60009081526001919091016020526040902054151590565b5490565b600081815260018301602052604081205480156108d9578354600019808301919081019060009087908390811061085057fe5b906000526020600020015490508087600001848154811061086d57fe5b60009182526020808320909101929092558281526001898101909252604090209084019055865487908061089d57fe5b60019003818190600052602060002001600090559055866001016000878152602001908152602001600020600090556001945050505050610309565b6000915050610309565b80356102b481610b55565b600080600060608486031215610902578283fd5b833561090d81610b55565b9250602084013561091d81610b55565b929592945050506040919091013590565b60006020828403121561093f578081fd5b5035919050565b60008060408385031215610958578182fd5b82359150602083013561096a81610b55565b809150509250929050565b60008082840360e0811215610988578283fd5b8335925060c0601f198201121561099d578182fd5b506020830190509250929050565b600080604083850312156109bd578182fd5b50508035926020909101359150565b6001600160a01b0391909116815260200190565b901515815260200190565b90815260200190565b6020808252601390820152726d757374206861766520555345525f524f4c4560681b604082015260600190565b6020808252600c908201526b696e76616c696420636f646560a01b604082015260600190565b6020808252601690820152756d75737420686176652043524541544f525f524f4c4560501b604082015260600190565b9586526020860194909452604085019290925260608401526001600160a01b0316608083015260a082015260c00190565b60089190910291821b60001990921b9182169119161790565b81358155602082013560018201556040820135600282015560038101610aee606084013560008354610aa8565b9055610b0a610aff608084016108e3565b600060048401610b1d565b61037260a0830135600060058401610b43565b805460089290920292831b6001600160a01b0390931b9283169219909116919091179055565b610b4f83838354610aa8565b90555050565b6001600160a01b0381168114610b6a57600080fd5b5056fe456e756d657261626c655365743a20696e646578206f7574206f6620626f756e6473416363657373436f6e74726f6c3a2073656e646572206d75737420626520616e2061646d696e20746f206772616e74828634d95e775031b9ff576b159a8509d3053581a8c9c4d7d86899e0afcd882f416363657373436f6e74726f6c3a2073656e646572206d75737420626520616e2061646d696e20746f207265766f6b6514823911f2da1b49f045a0929a60b8c1f2a7fc8c06c7284ca3e8ab4e193a08c8416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636520726f6c657320666f722073656c66a264697066735822122035ad2f808ae9955304053e56cb9e06f96fdc64834805b51acbe965f66f82111564736f6c63430007040033";

export class InviteCode__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<InviteCode> {
    return super.deploy(overrides || {}) as Promise<InviteCode>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): InviteCode {
    return super.attach(address) as InviteCode;
  }
  connect(signer: Signer): InviteCode__factory {
    return super.connect(signer) as InviteCode__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): InviteCodeInterface {
    return new utils.Interface(_abi) as InviteCodeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): InviteCode {
    return new Contract(address, _abi, signerOrProvider) as InviteCode;
  }
}
